import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const AppLoader = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <CircularProgress size={65} />
      <Typography variant="h6" sx={{ fontWeight: 500, }}>
        Loading...
      </Typography>
    </Box>
  );
};

export default AppLoader;
